<template>
<div class="legal-list">
  <div class="header-wrap">
    <el-button size="mini" type="primary" @click="searchList()">搜索</el-button>
<!--    <el-button size="mini" type="primary" @click="exportExcel()">自催报表明细</el-button>-->
<!--    <el-button size="mini" type="primary" @click="exportExcel2()">自催报表统计</el-button>-->
  </div>
  <div class="header-btn">
    <el-badge :value="all_count" class="btn-item">
      <el-button @click="onLabelBtn()">全部</el-button>
    </el-badge>
    <template v-for="(item,index) in label_type_list">
      <el-badge :key="index" :value="item.num" class="btn-item">
        <el-button @click="onLabelBtn(item)">{{ item.name }}</el-button>
      </el-badge>
    </template>
  </div>
  <div>
    <div class="table-wrap">
      <el-table
        v-loading="loading"
        v-if="pageData" :data="pageData.list"
        border
        style="width: 100%" height="60vh">
        <el-table-column
          prop="HouseName"
          label="房产" width="320" fixed></el-table-column>
        <el-table-column
          prop="name"
          label="业主姓名"
          width="150" fixed>
        </el-table-column>
        <el-table-column
          prop="phone"
          label="业主电话"
          width="180">
        </el-table-column>
        <el-table-column
          prop="butler_name"
          label="催费人员"
          width="100">
        </el-table-column>
        <el-table-column
          prop="账龄类型"
          label="账龄类型"
          width="90">
        </el-table-column>
        <el-table-column
          prop="type_tip"
          label="催费方式"
          width="90">
        </el-table-column>
        <el-table-column
          prop="send_time"
          label="催费日期"
          width="100">
        </el-table-column>
        <el-table-column
          prop="上次缴费时间"
          label="上次缴费时间"
          width="150">
        </el-table-column>
        <el-table-column
          prop="第一次催费时间"
          label="第一次催费时间"
          width="150">
        </el-table-column>
        <el-table-column
          prop="第二次催费时间"
          label="第二次催费时间"
          width="150">
        </el-table-column>
        <el-table-column
          prop="第三次催费时间"
          label="第三次催费时间"
          width="150">
        </el-table-column>
        <el-table-column
          prop="created_at"
          label="添加时间"
          width="150">
        </el-table-column>
        <el-table-column
          label="	操作"
          width="180" fixed="right">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" icon="el-icon-view" @click="preView(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-wrap">
      <el-pagination background layout="prev, pager, next" :total="pageData.total*1"
                     :page-size="pageData.pageSize*1" :current-page="pageData.page*1"
                     @current-change="pageChange"></el-pagination>
    </div>
  </div>
  <LegalHouseInfo ref="LegalHouseInfo" />
</div>
</template>

<script>

import {CommonHelp} from "../../common/CommonHelp";
import LegalHouseInfo from "../LegalHouseInfo";
import ButlerHttp from "../../common/ButlerHttp";

export default {
  name: "LegalList",
  components: {LegalHouseInfo},
  inject:['reginWhere','where'],
  data() {
    return {
      loading: false,
      labelObj: {
        1: "短  信",
        2: "催费函(线上)",
        3: "法务函(线上)",
        4: "律师函",
        5: "诉 讼",
        6: "立码付",
        7: "上  门",
        8: "电  话",
        9: "微  信",
        10: "已缴费",
        11: "短信(线下)",
        12: "催费函(线下)",
        13: "法务函(线下)",
        14: "第三方催费",
        15: "一户一码"
      },
      label_type_list: [
        {type: 1, name: "短信(线上)"},
        {type: 2, name: "催费函(线上)"},
        {type: 3, name: "法务函(线上)"},
        {type: 4, name: "律师函"},
        // {type:5,name:"诉 讼"},
        // {type:5,name:"诉讼(提交)",type_ex:1},
        // {type:5,name:"诉讼(诉调)",type_ex:2},
        // {type:5,name:"诉讼(立案)",type_ex:3},
        {type: 6, name: "立码付"},
        {type: 7, name: "上  门"},
        {type: 8, name: "电  话"},
        {type: 9, name: "微  信"},
        {type: 11, name: "短信(线下)"},
        {type: 12, name: "催费函(线下)"},
        {type: 13, name: "法务函(线下)"},
        // {type:14,name:"第三方催费"},
        {type: 15, name: "一户一码"},
        {type: 10, name: "已缴费"},
      ],
      pageData: {
        list: [],
        total: 0,
        pageSize: 20,
        page: 1,
      },
      all_count: 0,
    }
  },
  mounted() {
    const that=this;
    CommonHelp.debounce(()=>{
      that.pageChange(1)
      that.getAjaxCount()
    },500,that)
  },
  methods:{
    searchList(){
      this.pageData= {
        list: [],
        total: 0,
        pageSize: 20,
        page: 1,
      };
      this.getAjaxCount()
      this.getList()
    },
    getList() {
      const that = this;
      that.loading = true;
      let where = ERP.reJson(that.where)
      if(that.reginWhere.project_region) where.region_id=that.reginWhere.project_region;
      if(that.reginWhere.project_name) where.project_id=that.reginWhere.project_name;
      if(that.reginWhere.project_ids&&that.reginWhere.project_ids.length) where.project_ids=that.reginWhere.project_ids;
      if(that.reginWhere.area_id) where.area_id=that.reginWhere.area_id;
      if(that.reginWhere.age) where.age=that.reginWhere.age;

      ButlerHttp.post("LegalLitigation/getList", {
        ...where,
        page: that.pageData.page,
        page_size: that.pageData.pageSize
      }, res => {
        if (res.code) {
          that.pageData = res.data;
        }
        that.loading = false;
      });
    },
    getAjaxCount(){
      const that = this;
      let where = ERP.reJson(that.where)
      if(that.reginWhere.project_region) where.region_id=that.reginWhere.project_region;
      if(that.reginWhere.project_name) where.project_id=that.reginWhere.project_name;
      if(that.reginWhere.project_ids&&that.reginWhere.project_ids.length) where.project_ids=that.reginWhere.project_ids;
      if(that.reginWhere.area_id) where.area_id=that.reginWhere.area_id;
      if(that.reginWhere.age) where.age=that.reginWhere.age;
      ButlerHttp.post("LegalLitigation/ajaxCount", where, res => {
        if (res.code) {
          let label_type_list = that.label_type_list;
          label_type_list = label_type_list.map(ret => {
            let item_list = res.data.filter(r => {
              if (ret.type_ex !== undefined) {
                return ret.type == r.type && ret.type_ex == r.type_ex;
              } else {
                return ret.type == r.type;
              }
            });
            ret.num = item_list.reduce((prev, cur) => prev + cur.count, 0);
            return ret;
          });
          that.label_type_list = label_type_list;
          that.type_list = res.data;
          that.all_count = res.data.reduce((p, n) => {
            return p + (n.type === 10 ? 0 : n.count);
          }, 0);
        }
      });
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    onLabelBtn(item=null){
      this.where.type=(item||{}).type||"";
      this.where.type_ex=(item||{}).type_ex||"";
      this.pageData= {
        list: [],
        total: 0,
        pageSize: 20,
        page: 1,
      };
      this.getList()
    },
    preView(item){
      this.$refs.LegalHouseInfo.show(item)
    },
    exportExcel() {
      const that = this;
      let where = ERP.reJson(that.where)
      if(that.reginWhere.project_region) where.region_id=that.reginWhere.project_region;
      if(that.reginWhere.project_name) where.project_id=that.reginWhere.project_name;
      if(that.reginWhere.project_ids&&that.reginWhere.project_ids.length) where.project_ids=that.reginWhere.project_ids;
      if(that.reginWhere.area_id) where.area_id=that.reginWhere.area_id;
      if(that.reginWhere.age) where.age=that.reginWhere.age;
      const loading=that.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      ERP.postRequest({
        url: "admin/ExcelTask/addTask",
        data: {
          taskName:"催缴明细报表",
          targetController:"LegalExcel",
          targetFunction:"exportExcel_cmd",
          ...where,
        }
      }, res => {
        loading.close()
        that.$message.success('点击右下角下载按钮查看');
      })
    },
    exportExcel2() {
      const that = this;
      let where = ERP.reJson(that.where)
      if(that.reginWhere.project_region) where.region_id=that.reginWhere.project_region;
      if(that.reginWhere.project_name) where.project_id=that.reginWhere.project_name;
      if(that.reginWhere.project_ids&&that.reginWhere.project_ids.length) where.project_ids=that.reginWhere.project_ids;
      if(that.reginWhere.area_id) where.area_id=that.reginWhere.area_id;
      if(that.reginWhere.age) where.age=that.reginWhere.age;

      const loading=that.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      ERP.postRequest({
        url: "admin/ExcelTask/addTask",
        data: {
          taskName:"催缴报表统计",
          targetController:"LegalExcel",
          targetFunction:"exportExcel2_cmd",
          ...where,
        }
      }, res => {
        loading.close()
        that.$message.success('点击右下角下载按钮查看');
      })
    },
  },
  watch:{
    "reginWhere.project_ids":function(n,o){
      const that=this;
      CommonHelp.debounce(()=>{
        that.pageChange(1)
        that.getAjaxCount()
      },500,that)
    },
    "reginWhere.project_name":function(n,o){
      const that=this;
      CommonHelp.debounce(()=>{
        that.pageChange(1)
        that.getAjaxCount()
      },500,that)
    },
    "reginWhere.area_id":function(n,o) {
      const that = this;
      CommonHelp.debounce(() => {
        that.pageChange(1)
        that.getAjaxCount()
      }, 500, that)
    },
    "reginWhere.age":function(n,o) {
      const that = this;
      CommonHelp.debounce(() => {
        that.pageChange(1)
        that.getAjaxCount()
      }, 500, that)
    },
    "where.text":function(n,o) {
      const that = this;
      CommonHelp.debounce(() => {
        that.pageChange(1)
        that.getAjaxCount()
      }, 500, that)
    },
    "where.start_time":function(n,o) {
      const that = this;
      CommonHelp.debounce(() => {
        that.pageChange(1)
        that.getAjaxCount()
      }, 500, that)
    },
    "where.end_time":function(n,o) {
      const that = this;
      CommonHelp.debounce(() => {
        that.pageChange(1)
        that.getAjaxCount()
      }, 500, that)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../common.scss";
.legal-list{
  .header-wrap {
    display: flex;
    margin-bottom: 10px;
  }

 .header-btn {
    margin-bottom: 10px;
  }

  .btn-item {
    margin-top: 10px;
    margin-right: 30px;
  }

 .table-wrap {
    margin-bottom: 20px;
  }

 .pagination-wrap {
    margin-top: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/legal_litigation/LegalLitigationList.vue